module.exports = __webpack_public_path__ + "img/icon_montepar4DJ.88e65c10.svg";